/**
 * Calls the OIDC-protected Health Events API. Same-origin (`/api/...`) - the SPA and the data
 * routes are on the same HTTP API / custom domain, so no CORS is involved. The bearer token is
 * validated by the API's JWT authorizer before the request reaches the Lambda.
 */
export async function fetchEvents(config, accessToken, accountId) {
  const base = config.apiBasePath ?? '/api';
  const path = accountId
    ? `${base}/events/${encodeURIComponent(accountId)}`
    : `${base}/events`;

  const res = await fetch(path, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (res.status === 401 || res.status === 403) {
    throw new Error('Not authorized - your session may have expired. Try signing in again.');
  }
  if (!res.ok) {
    throw new Error(`Request failed (${res.status}).`);
  }
  return res.json();
}
